import React, { useState } from "react";
import Typography from "antd/es/typography/Typography";
import Select from "antd/es/select";
import Button from "antd/es/button";
import Row from "antd/es/grid/row";
import Spin from "antd/es/spin";
import "./Assignments.less";
import { NotesDetailCard } from "../../../component";

import { useGetUpcomingAssignmentsQuery } from "../../../redux/services/assignment";
import { useSelector } from "react-redux";
import { EmptyCard } from "../../../component";
import { useGetStudentBatchesQuery } from "../../../redux/services/batches";

const { Option } = Select;

const Title = Typography;
const Assignments = () => {
  const { student_id } = useSelector((state) => state.auth);
  const { data: assignments, isLoading } = useGetUpcomingAssignmentsQuery({
    student_id: student_id,
  });
  const { data: batches, isLoading: batchLoading } =
    useGetStudentBatchesQuery(student_id);
  const coachingOptions = React.useMemo(() => {
    if (!batches?.data) return [];
    // Transform to options array using Object.entries
    return Object.entries(batches?.data).map(([id, name]) => ({
      value: name.coaching_name,
      label: name.coaching_name,
    }));
  }, [batches]);

  const [selectedCoaching, setSelectedCoaching] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleApply = () => {};
  return (
    <div className='assignment-notes-container'>
      <div className='classes-notes'>
        <Title className='title'>All Assignments</Title>
      </div>
      <div style={{ marginTop: "20px" }}>
        {/* Filter Section */}
        <div className='filter-section'>
          <Select
            placeholder='Coaching'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedCoaching(value)}
            allowClear
            options={coachingOptions}
            loading={batchLoading}
          ></Select>
          <Select
            placeholder='Course'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedCourse(value)}
            allowClear
          >
            <Option value='Chemistry'>Chemistry</Option>
            <Option value='Physics'>Physics</Option>
            <Option value='Math'>Math</Option>
          </Select>
          <Select
            placeholder='Subject'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedSubject(value)}
            allowClear
          >
            <Option value='Inorganic'>Inorganic</Option>
            <Option value='Mechanics'>Mechanics</Option>
            <Option value='Algebra'>Algebra</Option>
          </Select>
          <Button type='primary' onClick={handleApply}>
            Apply
          </Button>
        </div>

        {/* Cards Section */}
        <Spin spinning={isLoading}>
          <Row gutter={[16, 16]}>
            {assignments?.data?.length > 0 ? (
              assignments?.data?.map((lecture) => (
                <Row
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <NotesDetailCard
                    key={lecture.id}
                    lectureName={lecture.lecture_name}
                    lectureNumber={lecture.lecture_number}
                    date={lecture.date}
                    coachingLogo={lecture.coachingLogo}
                  />
                </Row>
              ))
            ) : (
              <EmptyCard text='No assignments found' />
            )}
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default Assignments;
